import React, {useState} from 'react';
import cx from 'classnames';
import take from 'ramda/src/take.js';
import {guid} from '@ultradent/utilities/Guid';
import {isEmptyOrNil} from '@ultradent/utilities/EmptyOrNil';
import {t} from '../../util/i18n';

const TRUNC_THRESHOLD = 3;
const TruncatedList = ( {
                            list,
                            renderer,
                            itemProps,
                            maxLength,
                            className
                        } ) => {

    const remainingListCount = list.length - maxLength;
    const [showAll, setShowAll] = useState( (remainingListCount < TRUNC_THRESHOLD) ? true : false );
    const takeSize = showAll ? list.length : maxLength;
    const Component = renderer;

    if ( isEmptyOrNil( list ) ) {
        return <div className={cx( className )}>{t( 'lists.label.empty', 'No Items in this list' )}</div>
    }

    return (
        <div className={cx( className )}>
            {take( takeSize, list ).map( props => <Component key={guid()} {...props} {...itemProps}/> )}
            {remainingListCount >= TRUNC_THRESHOLD &&
                <span className="subheading-sm my-1 link-2 cursor-pointer"
                      onClick={() => setShowAll( state => !state )}>
                    {showAll
                        ? t( 'actionLabel.showLess', 'Show less' )
                        : t( 'label.plusMoreWithCount', '+ {{count}} more', {count: remainingListCount} )}
                </span>
            }
        </div>
    );
};

export default TruncatedList;
